import SearchParamsBase from '../../../Elements/SearchParamsBase';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import AuthService from '../../../Services/authService';

export default class ARAgeingReportSearchParams extends SearchParamsBase {
  static saveType = 'ARAgeingReportSearchParams';
  initialize() {
    this.OfficeIds = ARAgeingReportSearchParams.getUserOffice();
    this.CurrencyType = 'InvoiceCurrency';
  }

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return OfficeHelper.GetDefaultOfficeIds(user.officeId);
  }
}
